export const GRID_CONTAINER =
  'grid gap-[30px] mx-auto max-[1360px]:grid-cols-[repeat(6,100px)] max-[1360px]:w-[750px] min-[1360px]:grid-cols-[repeat(12,80px)] min-[1360px]:w-[1290px]';
export const HALF_WIDTH = 'max-[1360px]:col-span-3 min-[1360px]:col-span-6';
export const FULL_WIDTH = 'max-[1500px]:col-span-6 min-[1360px]:col-span-12';
export const ONE_THIRD_WIDTH = 'max-[1360px]:col-span-2 min-[1360px]:col-span-4';
export const LG_HALF_SM_FULL = 'max-[1360px]:col-span-6 min-[1360px]:col-span-6';
export const createFormFieldStyles = (flagged?: boolean, disabled?: boolean, error?: boolean) => {
  return [
    'body-text placeholder:text-grey-700',
    'block w-full rounded-md p-3 mt-0',
    'border transition-colors duration-150',
    disabled
      ? 'bg-grey-900 border-grey-800'
      : error
        ? 'bg-grey-950 border-error-50 ring-3 ring-error-50/8'
        : flagged
          ? 'bg-warning-50 border-warning focus:border-warning focus:ring-3 focus:ring-warning/12'
          : 'bg-grey-950 border-grey-800 focus:border-primary-50 focus:ring-3 focus:ring-primary-50/12',
  ];
};
